export default __webpack_public_path__ + "static/media/icon8.8a0f2cff.svg";